import axios from "axios";
import qs from 'qs';
import { message } from 'antd';
import { requestsConstants } from './requests.constants';
import { authHeader } from '../../helpers/auth-header';
import { client } from '../../actions';
import { requestListConstants } from './request-list.constants';
import {
	deprecatedDateRangeValuesAdapter,
  filterConstants,
  filterKeyAdapterPairs,
} from './request-filter/model';
import { actions as expiredRequestActions } from '../../actions/expired-requests.actions'
import { notificationConstants } from "../../constants/notification.constants";
import { actions as newRequestActions } from "../CreateRequest/new-request.actions";
import moment from 'moment';
import { fromDateStr, toDateStr } from "../../helpers/utcDate";
import request from "../../helpers/request";
import { getUniqueRequestsCreators } from './utils/getUniqueRequestsCreators';
import {ranges as filterDateRanges} from '../../components/DateRangePickerFooter/constants'
 
const url = '/Request';
let dspxFilterTimer;
let cancelFetchRequests
let cancelFetchExpiredRequests

const isAllTimeRange = (dateRange) => {
  if (!dateRange || !dateRange[0]) return false;
  const startDate = dateRange[0];
  if (!startDate || typeof startDate.year !== 'function') return false;
  const startYear = startDate.year();
  return startYear < 1500;
};

export const requestsActions = {
	closeFilter,
	closeReport,
	searchRequestByNumber,
	fetchRequests,
	fetchReports,
	fetchCreationMethods,
	fetchServices,
	fetchCompanies,
	fetchWorkers,
	fetchExecuters,
  fetchCreators,
	fetchStatuses,
	fetchDistricts,
	setDateRange,
	setAddrPorchValue,
	setAddrFloorValue,
	setAddrTypeFlatValue,
	setAddrFlatValue,
	setFlatValueByPorchFloor,
	setStageCurrentFlatValue,
	setStageFlatValue,
	setAcceptanceStatusesFlatValue,
	setDateRangeField,
  setRelatedToExpired,
	setReport,
	setRequestsFailedValue,
	fetchFailedFile,
	clearFailedFile,
	//downloadReport,
	applyCompany,
	applyMethodCreatingRequest,
  applyPrioritiesRequest,
	applyWorker,
	applyExecuter,
  applyCreator,
	applyPaymentState,
	applyStatus,
	applyService,
	applySubservice,
	applyAddrStreet,
	applyAddrBuilding,
	applyPhone,
	applyRating,
	applyWarranty,
	applyNotWarranty,
	applyPossWarranty,
	applyRetry,
	applyBadWork,
	applyWaiting,
	applyChargeable,
	applyIsOrder,
	applyExpiredOnly,
	applyImmediate,
	applyInternal,
	applyDistrict,
	// applyUserCreatedOnly,
	applyAttachmentFilter,
	applyWarrantyOrg,
	resetFilter,
	backFilter,
	fetchExpiredRequests,
	notificationRequest,
	getHistory,
	switchFavorites,
	setRequestAddressFilter,
	setSavedFilter,
	retrieveLastState,
	setImportResult,
  fetchImportResultRequests,
	setValueCheckedStage,
	fetchStages,
	fetchAcceptanceStatuses,
	setShowModalStage,
	setShowModalChess,
	setActiveRequest,
	applyClientName,
};

export const buildRequestsFiltersParams = ({ filterStore }) => {
  let rurl = '';

  const {
    valueRating,
    valuePhone,
    valueSubservice,
    valueService,
    valueAddrStreet,
    valueAddrBuilding,
    valueAddrFlat,
		valueFlatByPorchFloor,
		valueStageFlat,
		valueStageCurrentFlat,
		valueAddrTypeFlat,
		valueAcceptanceStatusesFlat,
		valueCheckedStage,
    dateRange,
		alertDateRange,
    // selectedDateRange,
    dateRangeField,
    valueMethodCreatingRequest,
    valuePriorityRequest,
    valueWorker,
    valueExecuter,
    valueCreator,
		valuePaymentState,
    valueStatus,
    valueCompany,
    valueDistrict,
    valueWarrantyOrg,
    warranty,
    notWarranty,
    possWarranty,
    badWork,
    waiting,
    retry,
    chargeable,
    isOrder,
    expiredOnly,
    // userCreatedOnly,
    immediate,
    internal,
    favorites,
    attachmentFilter,
		valueClientName,
  } = filterStore;

  if (isAllTimeRange(dateRange) && (!valueCompany || valueCompany.length === 0)) {
    return '';
  }

  const warranties = [];
  notWarranty && warranties.push(0);
  warranty && warranties.push(1);
  possWarranty && warranties.push(2);

  rurl +=
    '?fromDate=' +
    fromDateStr(dateRange[0]) +
    '&toDate=' +
    toDateStr(dateRange[1]);
	
	if (dateRangeField != null) {
		rurl += '&filterDateMode=' + dateRangeField;
	}

	if(alertDateRange && alertDateRange?.length > 0) rurl +=  '&fromAlertDate=' + fromDateStr(alertDateRange[0]) + '&toAlertDate=' + toDateStr(alertDateRange[1])
  if (valueMethodCreatingRequest && valueMethodCreatingRequest.length > 0) rurl += '&creationMethods=' + valueMethodCreatingRequest;
  if (valuePriorityRequest && valuePriorityRequest.length > 0) {
    rurl += '&PriorityIds=' + valuePriorityRequest.join(',');
  }
  if (valueWorker && valueWorker.length > 0) rurl += '&workers=' + valueWorker;
  if (valueExecuter && valueExecuter.length > 0) rurl += '&executors=' + valueExecuter;
  if (valueCreator && valueCreator.length > 0) {
    rurl += '&createWorkers=' + valueCreator;
  }
	if (valuePaymentState?.length > 0) rurl += '&paymentStates=' + valuePaymentState;
  if (valueStatus && valueStatus.length > 0) rurl += '&statuses=' + valueStatus;
  if (valueCompany && valueCompany.length > 0) rurl += '&companies=' + valueCompany;
  if (valueDistrict && valueDistrict.length > 0) rurl += '&regions=' + valueDistrict;
  if (valueAddrStreet && valueAddrStreet.length > 0) rurl += '&streets=' + valueAddrStreet;
  if (valueAddrBuilding && valueAddrBuilding.length > 0) rurl += '&houses=' + valueAddrBuilding;
	
	const flatVal = valueAddrFlat?.length ? valueAddrFlat : valueFlatByPorchFloor;
  if (flatVal?.length > 0) rurl += '&addresses=' + flatVal;
		if(valueAddrTypeFlat?.length > 0) rurl += '&addressTypeIds=' + valueAddrTypeFlat;
	if (valueStageFlat && valueStageFlat.length > 0 && valueCheckedStage) rurl += '&addressStagesLifeCycle=' + valueStageFlat;
	if (valueStageCurrentFlat && valueStageCurrentFlat.length > 0 && valueCheckedStage) rurl += '&addressStagesLifeCycleCurrent=' + valueStageCurrentFlat;
	if (valueAcceptanceStatusesFlat && valueAcceptanceStatusesFlat.length > 0 && valueCheckedStage) rurl += '&acceptanceStatusAddressLifeCycle=' + valueAcceptanceStatusesFlat;
  if (valueService && valueService.length > 0) rurl += '&parentServices=' + valueService;
  if (valueSubservice && valueSubservice.length > 0) rurl += '&services=' + valueSubservice;
  if (valueWarrantyOrg && valueWarrantyOrg.length > 0) rurl += '&warrantyOrgs=' + valueWarrantyOrg;
  if (valuePhone) rurl += '&clientPhone=' + valuePhone;
  if (valueRating && valueRating.length > 0) rurl += '&ratings=' + valueRating;
  if (warranty || possWarranty) rurl += '&warranties=' + warranties;
  if (notWarranty) rurl += '&warranties=' + warranties;
  if (badWork) rurl += '&badWork=true';
  if (waiting) rurl += '&isWaiting=true';
  if (retry) rurl += '&onlyRetry=true';
  if (chargeable) rurl += '&chargeable=true';
  if (isOrder) rurl += '&isPaidService=true';
  if (expiredOnly) rurl += '&onlyExpired=true';
  // if (userCreatedOnly) rurl += '&onlyByClient=true';
  if (immediate) rurl += '&immediates=1';
  if (internal) rurl += '&internal=true';
  if (favorites) rurl += '&onlyFavorites=true';
  if (attachmentFilter) rurl += `&hasAttachment=${attachmentFilter}`;
	if (valueClientName) rurl += `&clientName=${valueClientName}`

  return rurl;
};

async function getHistory(requestId) {
	const rurl = `/Request/change_history/${requestId}`
	
	try {
		const res = await client.get(rurl, { headers: authHeader() });
		if (res.status === 200) {
			return res.data;
		} else {
			return [];
		}
	} catch (err) {
		console.log(err.request);
		return [];
	}
}

function fetchExpiredRequests() {
  let rurl = '/Request/expired_requests';
  cancelFetchRequests && cancelFetchRequests();
  return (dispatch, getState) => {
    const state = getState();
    const { relatedToExpired } = state.filterStore;
    let queryParamsString = '';
    if (relatedToExpired) {
      const params = buildRequestsFiltersParams(state);
      if (params === '') {
        return;
      }
      queryParamsString = params + '&applyFilter=true';
    }
    dispatch({
      type: requestsConstants.FETCH_EXPIRED_REQUESTS,
      payload: client.get(rurl + queryParamsString, {
        headers: authHeader(),
      }),
    });
  };
}

function resetFilter() {
	return async dispatch => {
		dispatch({
			type: filterConstants.RESET_FILTER,
		})
		cancelFetchRequests()
		dispatch(fetchRequests(undefined, undefined, undefined, true))
		await dispatch(setRelatedToExpired(true))

		const res = await client.get('/Filter/default', { headers: authHeader() })
		const filter = res.data
		if(filter) {
			const data = { id: filter.id, value:false}
			client.put('/Filter/default', data, { headers: authHeader() })
		} 

	}
}

function backFilter() {
	return dispatch => {
		dispatch({
			type: filterConstants.BACK_FILTER,
		})
		cancelFetchRequests()
		dispatch(fetchRequests())
	}
}

function switchFavorites() {
	return (dispatch, getState) => {

		const {favorites} = getState().filterStore

		dispatch({
			type: filterConstants.SWITCH_FAVORITES,
			payload: !favorites
		})
		cancelFetchRequests()
		dispatch(fetchRequests())
	}
}

const adaptFilter = (filter) => {
  const data = JSON.parse(filter);
  for (const [fromKey, toKey] of filterKeyAdapterPairs) {
    if (data.hasOwnProperty(fromKey)) {
      data[toKey] = data[fromKey];
      delete data[fromKey];
    }
  }

	data.dateRangeField =
		deprecatedDateRangeValuesAdapter[data.dateRangeField] ??
		data.dateRangeField;

  return data;
};

function setSavedFilter({filter})  {
	const data = adaptFilter(filter.filter);

	return async (dispatch, getState ) => {
		const {
      selectedDateRange,
			valueAddrStreet,
			valueAddrBuilding,
			valueService,
			dateRange,
			valueCompany,
		} = data;

		const serviceCompanyFilter = getState().authentication.userInfo.ServiceCompanyFilter;

		await dispatch(fetchAddrBuildingList(valueAddrStreet));
		await dispatch(fetchAddrFlatList(valueAddrBuilding));
		if(valueService) {
			await dispatch(fetchSubserviceList(valueService));
		}

		await dispatch({
			type: filterConstants.SELECT_SAVED_FILTER,
			payload: { filterData: filter, filter: data }
		})

		const showWeekForward = true;

		const dRanges = filterDateRanges(showWeekForward)

		if(selectedDateRange) {
			if (selectedDateRange.id ){
				const range = dRanges?.find((item) => item.id === selectedDateRange.id)?.range || selectedDateRange.range;
				dispatch({
					type: filterConstants.SELECT_DATE_RANGE,
					payload: {
						id: selectedDateRange.id,
						name: selectedDateRange.name,
						range
					}

				})
			}
			else {
				dispatch({
					type: filterConstants.SELECT_DATE_RANGE,
					payload: {
						id: null,
						name: null,
						range: selectedDateRange.range.map(item => moment(item)),
					}
				})
			}

		}

		if(cancelFetchRequests) cancelFetchRequests()

		if (isAllTimeRange(dateRange) && (!valueCompany || valueCompany.length === 0) && serviceCompanyFilter) {
			message.error('При выборе диапазона "Все время" необходимо выбрать УК');
			return;
		}

		dispatch(fetchRequests(undefined, undefined, undefined, true))
	}
}

function setRequestAddressFilter(data)  {
	return async (dispatch, getState ) => {
		const {streetId, houseId, addressId, fullAddress} = data;

		await dispatch(fetchAddrBuildingList([streetId]));
		await dispatch(fetchAddrFlatList([houseId]));

		dispatch({
			type: filterConstants.APPLY_ADDRESS_FILTER,
			payload: { 
				filterName: fullAddress,
				valueAddrStreet: [streetId+''],
				valueAddrBuilding: [houseId+''],
				valueAddrFlat : [addressId+''] }
		})
		cancelFetchRequests()
		dispatch(fetchRequests())
	}
}

function fetchRequestsTimer(dispatch) {
	dspxFilterTimer && clearTimeout(dspxFilterTimer);
	cancelFetchRequests && cancelFetchRequests();
	dspxFilterTimer = setTimeout(() => { dispatch(fetchRequests(undefined, undefined, undefined, true)) }, 1100);
}

function fetchRequests(requestNumber, forReport, resetPostRequestID = true, needGetExpiredCount = false) {
	return (dispatch, getState) => {

		cancelFetchRequests && cancelFetchRequests()

		const state = getState();

		const {
			report,
			reports,
		} = state.requestsStore;

		const {filterStore} = state;

		const serviceCompanyFilter = getState().authentication.userInfo.ServiceCompanyFilter

		const { popupRequest } = state.notificationStore

		const postRequestId = state.newRequestStore.postRequestID;

    let queryParamsString = '';

		if (requestNumber || popupRequest) {
			const rid = requestNumber ? requestNumber : popupRequest
      queryParamsString += '?requestId=' + rid;
		}
		else {
      queryParamsString += buildRequestsFiltersParams(getState());
      if (isAllTimeRange(filterStore.dateRange) && (!filterStore.valueCompany || filterStore.valueCompany.length === 0) && serviceCompanyFilter) {
        message.error('При выборе диапазона "Все время" необходимо выбрать УК');
        return;
      }
		}

		if (forReport) {
			report && report.forEach(el => {
				const r = reports.find(rel => rel.id == el)
				const u = r.url + queryParamsString
				client.get(u, { headers: authHeader() }).then(response => {
					let data = Buffer.from(response.data, "base64");
					const url = window.URL.createObjectURL(new Blob([data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', r.name + '.' + r.extension);
					document.body.appendChild(link);
					link.click();

				})
			})
		} else {
			let CancelToken = axios.CancelToken
			dispatch({
				type: requestsConstants.FETCH_REQUESTS,
				payload: client.get(url + queryParamsString, {
						headers: authHeader(),
						cancelToken: new CancelToken(function executor(c) {
							cancelFetchRequests = c; })})
					.catch(error => {
						console.log("*** FETCH_REQUESTS error ")
						console.log(error)
						if (axios.isCancel(error)) {
							console.log('Request canceled', error.message);
						}
					})
			})

			dispatch({
				type: requestListConstants.SET_SELECTED_ROWS,
				payload: []
			})

      if (needGetExpiredCount) {
        const { relatedToExpired } = state.filterStore;
        const bool = Boolean(relatedToExpired);
        if (bool) {
          dispatch(
            expiredRequestActions.getExpiredCount({ relatedToExpired: true })
          );
        }
      }

			if (resetPostRequestID && postRequestId) {
				dispatch(newRequestActions.resetPostedRequest())
			}
		}
	}
}

/*
function downloadReport() {
	return (dispatch, getState) => {

		const {
			report,
			reports,
			valueRating,
			valuePhone,
			valueSubservice,
			valueService,
			valueAddrStreet,
			valueAddrBuilding,
			valueAddrFlat,
			dateRange,
			dateRangeField,
			valueWorker,
			valueExecuter,
			valueStatus,
			valueCompany,
			valueDistrict,
			warranty,
			notWarranty,
			possWarranty,
			badWork,
			retry,
			chargeable,
			immediate,
		} = getState().requestsStore;

		if (!report) return

		const warranties = [];
		notWarranty && warranties.push(0);
		warranty && warranties.push(1);
		possWarranty && warranties.push(2);

		let rurl = '';

		let byCreate = dateRangeField === 'create_time';
		rurl += '?filterByCreateDate=' + byCreate
			+ '&fromDate=' + dateRange[0].format('YYYY-MM-DD')
			+ '&toDate=' + dateRange[1].format('YYYY-MM-DD');

		if (valueWorker && valueWorker.length > 0) rurl += '&workers=' + valueWorker;
		if (valueExecuter && valueExecuter.length > 0) rurl += '&executors=' + valueExecuter;
		if (valueStatus && valueStatus.length > 0) rurl += '&statuses=' + valueStatus;
		if (valueCompany && valueCompany.length > 0) rurl += '&companies=' + valueCompany;
		if (valueDistrict && valueDistrict.length > 0) rurl += '&regions=' + valueDistrict;
		if (valueAddrStreet && valueAddrStreet.length > 0) rurl += '&streets=' + valueAddrStreet;
		if (valueAddrBuilding && valueAddrBuilding.length > 0) rurl += '&houses=' + valueAddrBuilding;
		if (valueAddrFlat && valueAddrFlat.length > 0) rurl += '&addresses=' + valueAddrFlat;
		if (valueService && valueService.length > 0) rurl += '&parentServices=' + valueService;
		if (valueSubservice && valueSubservice.length > 0) rurl += '&services=' + valueSubservice;
		if (valuePhone) rurl += '&clientPhone=' + valuePhone;
		if (valueRating && valueRating.length > 0) rurl += '&ratings=' + valueRating;
		if (warranty || possWarranty) rurl += '&warranties=' + warranties;
		if (notWarranty) rurl += '&warranties=' + warranties;
		if (badWork) rurl += '&badWork=true';
		if (retry) rurl += '&onlyRetry=true';
		if (chargeable) rurl += '&chargeable=true';
		if (immediate) rurl += '&immediates=1';

		report.forEach(el => {
			const r = reports.find(rel => rel.id == el)
			const u = r.url + rurl
			console.log(u)

			client.get(u, { headers: authHeader() }).then( response => {
				let data = Buffer.from(response.data, "base64");
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', r.name+'.xml'); 
				document.body.appendChild(link);
				link.click(); 

			})
		})

	}
} */

function fetchReports() {
	let rurl = '/report/awailable';

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_REPORTS,
			payload: client.get(rurl, { headers: authHeader() })
		})

		dispatch(setReport(['1']))
	}
}

function fetchCreationMethods() {
	let rurl = url + '/creation_methods';

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_CREATION_METHODS,
			payload: request.get(
				rurl, 
				{},
				'Не удалось загрузить возможные способы создания',
				[]
			)
		})
	}
}

function fetchCompanies() {
	let rurl = url + '/companies';

	return dispatch => {
		dispatch({
			type: filterConstants.SET_FILTER_COMPANY,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchDistricts() {
	let rurl = url + '/city_regions';

	return dispatch => {
		//const d = [{id: 28, name: 'Юбилейный'},{id: 29, name: 'Центральный'}]
		dispatch({
			type: filterConstants.SET_FILTER_DISTRICT,
			//payload:  new Promise((resolve=>resolve({data: d})))  //client.get(rurl, { headers: authHeader() })
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchServices() {

	return (dispatch, getState) => {

		let rurl = url + '/parent_services'

		dispatch({
			type: filterConstants.SET_FILTER_SERVICE,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchWorkers(opt) {
	let rurl = url + '/workers';

	return dispatch => {
		dispatch({
			type: filterConstants.SET_FILTER_WORKER,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchStages() {
	let rurl = '/FlatsGrid/stage_address_life_cycle';

	return dispatch => {
		dispatch({
			type: filterConstants.SET_FILTER_STAGE,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchAcceptanceStatuses() {
	let rurl = '/FlatsGrid/acceptance_statuses_address_life_cycle';

	return dispatch => {
		dispatch({
			type: filterConstants.SET_FILTER_ACCEPTANCE_STATUSES,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchExecuters(opt) {
	let rurl = url + '/executers';

	return dispatch => {
		dispatch({
			type: filterConstants.SET_FILTER_EXECUTER,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchCreators(opt) {
  const creators = getUniqueRequestsCreators({
    requests: opt?.requests || [],
    creators: opt?.filterCreator || [],
  });
  return (dispatch) => {
    dispatch({
      type: filterConstants.SET_FILTER_CREATOR,
      payload: Promise.resolve({ data: creators }),
    });
  };
}

function fetchStatuses(opt) {
	let rurl = url + '/statuses'

	return dispatch => {
		client.get(rurl, { headers: authHeader() }).then(res=>{
			dispatch({
				type: filterConstants.SET_FILTER_STATUS,
				payload: new Promise((resolve, reject) => {
					const sts = res.data
					sts.sort((a,b)=>a.orderNum - b.orderNum)		
					resolve({ data: sts });
				})
			})

		})
	}
}

function closeFilter(visible) {
	return dispatch => {
		dispatch({
			type: requestsConstants.CLOSE_FILTER,
			payload: visible
		})
	}
}

function closeReport(visible) {

	var OneSignal = window.OneSignal || [];

	/*OneSignal.sendSelfNotification(
		"DISPEX Web Push Notification",
		"Action buttons increase the ways your users can interact with your notification.", 
		'http://localhost:3000',
		null,
		{
			notificationType: 'news-feature'
		}, 
	); */

	return dispatch => {
		dispatch({
			type: requestsConstants.CLOSE_REPORT,
			payload: visible
		})
	}
}

function setReport(filter) {

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_REPORT,
			payload: filter
		})
	}
}

function setRequestsFailedValue(value) {

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_REQUESTS_FAILED_VALUE,
			payload: value
		})
	}
}

function clearFailedFile() {

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_FAILED_FILE_FETCH_CLEAR,
		})
	}
}

function fetchFailedFile(failedRequests) {
	const rurl = '/Report/requests_mass_actions'

	const requestBody = failedRequests.map((item) => (
		{
			RequestId: item.id,
			IsSuccess: false,
			Reason: item.reason,
		}
	))

	const requestBodyJSON = JSON.stringify(requestBody);

	return dispatch => {
		dispatch({
			type: requestsConstants.SET_FAILED_FILE_FETCH_DATA,
			payload: request.post(
				rurl, 
				requestBodyJSON,
				'Не удалось загрузить файл заявок',
			)
		})
	}
}

function applyCompany(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_COMPANY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyDistrict(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_DISTRICT,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyWarrantyOrg(filter) {
	
	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_WARRANTY_ORG,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}


function applyMethodCreatingRequest(filter) {
  return (dispatch) => {
    dispatch({
      type: filterConstants.APPLY_METHOD_CREATING_REQUEST,
      payload: filter,
    });
    // fetchRequestsTimer(dispatch);
  };
}

function applyPrioritiesRequest(filter) {
  return (dispatch) => {
    dispatch({
      type: filterConstants.APPLY_PRIORITY_REQUEST,
      payload: filter,
    });
    // fetchRequestsTimer(dispatch);
  };
}

function applyWorker(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_WORKER,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyExecuter(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_EXECUTER,
			payload: filter
		})
		// fetchRequestsTimer(dispatch);
	}
}

function applyCreator(filter) {
  return (dispatch) => {
    dispatch({
      type: filterConstants.APPLY_CREATOR,
      payload: filter,
    });
    // fetchRequestsTimer(dispatch);
  };
}

function applyPaymentState(filter) {
  return (dispatch) => {
    dispatch({
      type: filterConstants.APPLY_PAYMENT_STATE,
      payload: filter,
    });
    // fetchRequestsTimer(dispatch);
  };
}

function applyAttachmentFilter(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_ATTACHMENT_FILTER,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}


function applyWarranty(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_WARRANTY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyNotWarranty(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_NOT_WARRANTY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyPossWarranty(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_POSS_WARRANTY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyRetry(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_RETRY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyChargeable(filter) {
	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_CHARGEABLE,
			payload: filter
		})
		// fetchRequestsTimer(dispatch);
	}
}

function applyIsOrder(filter) {
	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_IS_ORDER,
			payload: filter
		})
		// fetchRequestsTimer(dispatch);
	}
}

// function applyUserCreatedOnly(filter) {
// 	return dispatch => {
// 		dispatch({
// 			type: filterConstants.APPLY_USER_CREATED,
// 			payload: filter
// 		})
// 		fetchRequestsTimer(dispatch);
// 	}
// }

function applyExpiredOnly(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_EXPIRED_ONLY,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyImmediate(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_IMMEDIATE,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyInternal(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_INTERNAL,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyBadWork(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_BADWORK,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}

function applyWaiting(filter) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_WAITING,
			payload: filter
		})
	}
}

function applyStatus(filter, opt) {
	// eslint-disable-next-line
	const option = { ...opt, valueStatus: filter }
	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_STATUS,
			payload: filter
		})

		// fetchRequestsTimer(dispatch);
	}
}


function setSubserviceValue(value) {
	return dispatch => {
		dispatch({
			type: requestsConstants.SET_SUBSERVICE_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function fetchSubserviceList(service) {

	let rurl = url + '/services?parentIds=' + service;

	return dispatch => {
		dispatch({
			type: filterConstants.FETCH_SUBSERVICE,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function applyService(value, opt) {
	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_SERVICE,
			payload: value
		})

		dispatch(fetchSubserviceList(value));
		dispatch(setSubserviceValue(undefined));
	}
}

function setAddrBuildingValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_ADDR_BUILDING_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setAddrPorchValue(value) {
	return dispatch => {
		dispatch({ type: filterConstants.SET_ADDR_PORCH_VALUE, payload: value })

		dispatch({
			type: filterConstants.SET_ADDR_TYPE_FLAT_VALUE,
			payload: undefined
		})
	}
}

function setAddrFloorValue(value) {
		return dispatch => {
		dispatch({ type: filterConstants.SET_ADDR_FLOOR_VALUE, payload: value })

		dispatch({
			type: filterConstants.SET_ADDR_TYPE_FLAT_VALUE,
			payload: undefined
		})
	}
}

function setAddrTypeFlatValue(value) {

	return dispatch => {
		dispatch({
			type: filterConstants.SET_ADDR_TYPE_FLAT_VALUE,
			payload: value
		})

		dispatch(setAddrFlatValue(undefined));
	}
}

function setAddrFlatValue(value) {

	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_ADDR_FLAT_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setFlatValueByPorchFloor(value) {
  return {
    type: filterConstants.SET_FLAT_VALUE_BY_PORCH_FLOOR,
    payload: value,
  };
}

function resetAddrValues() {
	return (dispatch) => {
		dispatch({ type: filterConstants.RESET_ADDR_VALUES });
		// fetchRequestsTimer(dispatch);
	}
}

function setStageFlatValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_STAGE_FLAT_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setStageCurrentFlatValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_STAGE_CURRENT_FLAT_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setAcceptanceStatusesFlatValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_ACCEPTANCE_STATUSES_FLAT_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setValueCheckedStage(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_VALUE_CKECKED_STAGE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setPhoneValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_PHONE_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setClientNameValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_CLIENT_NAME_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setRatingValue(value) {
	return (dispatch, getState) => {
		dispatch({
			type: filterConstants.SET_RATING_VALUE,
			payload: value
		})

		// fetchRequestsTimer(dispatch);
	}
}


function fetchAddrBuildingList(street) {

	let rurl = url + '/houses';
	if (street && street.length === 1 && !isNaN(street[0])) rurl += '/' + street[0];
	else return dispatch => {
		dispatch({
			type: filterConstants.FETCH_ADDR_BUILDING,
			payload: new Promise((resolve, reject) => {
				resolve({ data: [] });
			})
		});
	}

	return dispatch => {
		dispatch({
			type: filterConstants.FETCH_ADDR_BUILDING,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function fetchAddrFlatList(building) {

	let rurl = url + '/house_flat_cells';
	if (building && building.length === 1 && !isNaN(building[0])) rurl += '/' + building;
	else return dispatch => {
		dispatch({
			type: filterConstants.FETCH_ADDR_FLAT,
			payload: new Promise((resolve, reject) => {
				resolve({ data: [] });
			})
		});
	}

	return dispatch => {
		dispatch({
			type: filterConstants.FETCH_ADDR_FLAT,
			payload: client.get(rurl, { headers: authHeader() })
		})
	}
}

function applyAddrBuilding(value) {
	return dispatch => {
		dispatch({
			type: filterConstants.SET_ADDR_BUILDING_VALUE,
			payload: value
		})

		dispatch(fetchAddrFlatList(value));
		dispatch(resetAddrValues());
	}
}

function applyAddrStreet(value, opt) {

	return dispatch => {
		dispatch({
			type: filterConstants.APPLY_ADDR_STREET,
			payload: value
		})

		dispatch(fetchAddrBuildingList(value));
		dispatch(setAddrBuildingValue(undefined));
		dispatch(fetchAddrFlatList(undefined));
		dispatch(resetAddrValues());
	}
}

function applyPhone(value) {
	return dispatch => {
		dispatch(setPhoneValue(value));
	}
}

function applyClientName(value) {
	return dispatch => {
		dispatch(setClientNameValue(value));
	}
}

function applyRating(value) {
	return dispatch => {
		dispatch(setRatingValue(value));
	}
}

function applySubservice(value) {
	return dispatch => {
		dispatch(setSubserviceValue(value));
	}
}

function searchRequestByNumber(number) {
	return dispatch => {
		dispatch(fetchRequests(number));
	}
}

function notificationRequest(number) {
	return dispatch => {
		dispatch( { type: 'APPBAR_SET_PAGE', payload: 'Requests' } )				
		dispatch({
			type: notificationConstants.NOTIFICATION_POPUP,
			payload: number
		})		

		dispatch(fetchRequests(number, false, true));
	}
}

function setDateRange(dateRange) {
	return dispatch => {
		dispatch({
			type: filterConstants.SET_DATE_RANGE,
			payload: dateRange
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setShowModalStage(value) {
	return dispatch => {
		dispatch({
			type: requestsConstants.SET_SHOW_MODAL_STAGE,
			payload: value
		})
	}
}

function setActiveRequest(value) {
	return dispatch => {
		dispatch({
			type: requestsConstants.SET_ACTIVE_REQUEST,
			payload: value,
		})
	}
}

function setShowModalChess(value) {
	return dispatch => {
		dispatch({
			type: requestsConstants.SET_SHOW_MODAL_CHESS,
			payload: value
		})
	}
}

function setDateRangeField(rangeField) {
	return dispatch => {
		dispatch({
			type: filterConstants.SET_DATE_RANGE_FIELD,
			payload: rangeField
		})

		// fetchRequestsTimer(dispatch);
	}
}

function setRelatedToExpired(boolVal) {
  const rurl = '/Filter/expire_depend';
  return (dispatch) => {
    dispatch({
      type: filterConstants.SET_RELATED_TO_EXPIRED,
      payload: client.post(
        rurl,
        JSON.stringify(Boolean(boolVal)),
        {
          headers: authHeader(),
        },
      ).then(() => Boolean(boolVal)),
    });
  };
}

function retrieveLastState(state) {
	return dispatch => {
		dispatch({
			type: requestsConstants.RETRIEVE_LAST_STATE,
			payload: state
		})
	}
}

function setImportResult(importResult) {
	// importResult example
	/*
	{
		isLengthEqual: true,
		allAreOk: true,
		errorFiles: [
			{
				isOk: false,
				requestId: 1,
				error: 'Some error',
				fileWrapper: {
					name: 'test.docx',
					originalFileObj: File(),
					...someAntdFileWrapperProperties,
				},
        fileName: 'someFile.docx',
				fileUrl: 'blob:https://dispex.org/asd123asd',
			},
		],
		createdRequestIds: [1, 2, 3],
	}
	*/

	return (dispatch) => {
		dispatch({
			type: requestsConstants.SET_IMPORT_RESULT,
			payload: importResult || null,
		});
	};
}

function fetchImportResultRequests(requestIds) {
	// requestIds example
	/*
	[
		1,
		2,
		3,
	]
	*/

  const payload =
    Array.isArray(requestIds) && requestIds?.length
      ? client.get('/Request/id', {
          headers: authHeader(),
          params: {
            ids: requestIds,
          },
          paramsSerializer: (params) =>
            qs.stringify(params, {
              arrayFormat: 'repeat',
            }),
        })
      : Promise.resolve([]);

	return (dispatch) => {
		dispatch({
			type: requestsConstants.SET_IMPORT_RESULT_REQUESTS,
			payload: payload,
		});
	};
}
